import { Dropdown } from 'bootstrap'
import React,{useState, useEffect,useParams} from 'react'
import Footer from "../../Components/Footer"
import NavBar from "../../Components/NavBar"
import AsideLeftHome from '../../Components/AsideLeftHome'
import AsideRightHome from '../../Components/AsideRightHome'
import PostCard from "../../Components/MainPostCard"
import CardColumn from '../../Components/CardColumn'
import api from '../../lib/api'

//arreglams los estilos
//arreglamos un bug
//ya pintamos las cards

//perro ->ano
//gato -> mes
//hamster => semana
//los filtros funcionan, falta modularizarlos
//la busqueda funciona

export default function Home() {

    const [search,setSearch]=useState("")
    function getSearch(value){
        setSearch(value)
        console.log(value)
    }
	const [posts, setPosts] = useState([]);

	useEffect(async ()=>{
        const response =  await	api.getAllPosts();
        setPosts(response.data.posts)
    },[])
    return (
        
    <>
   	 <NavBar getSearch={getSearch}/>
	

	{/*--------------------------------------------------------------------------------------MAIN-----------------------------------------------------------------*/}
	<body>
  <main className="container-xl custom-container">
		<div className="row">
			{/*</div>-------------------------------------------------------------------ASIDE LEFT-----------------------------------------------------------------------------------------*/}
            <AsideLeftHome />
			{/*------------------------------------------------------------------------MAIN CARDS---------------------------------------------------------------------------*/}
			<CardColumn posts={posts}/>

			{/*</section>------------------------------------------------------------------ ASIDE RIGHT----------------------------------------------------------------------*/}

			<AsideRightHome data={posts} />
			
		</div>
	</main>
  </body>

	{/*--------------------------------------------------------------------------FOOTER---------------------------------------------------------------------------*/}
    <Footer />
  </>

  );
}
